<template>
  <v-dialog
    v-model="dialogVisible"
    max-width="500"
    class="rounded-xl"
    persistent
  >
    <v-card id="pdf_password_modal_card" width="100%" class="px-6 py-6">
      <v-form ref="formValid" v-model="formValid" @submit.prevent="setPassword">
        <v-card-title>{{ $t('documentSignatureCustomization.modal.pdfPassword.title') }}</v-card-title>
        <v-card-text class="pt-6">
          <v-container fluid>
            <v-row>
              <p v-if="pdfFilename">{{ $t('documentSignatureCustomization.modal.pdfPassword.filenameLabel', { filename: pdfFilename }) }} </p>
              <v-text-field
                id="pdf_password"
                ref="pdfPassword"
                v-model="pdf_password"
                tabindex="1"
                :append-icon="showPwd ? 'mdi-eye' : 'mdi-eye-off'"
                :label="$t('documentSignatureCustomization.modal.pdfPassword.label')"
                :type="showPwd ? 'text' : 'password'"
                prepend-icon="mdi-lock"
                :rules="[rules.required]"
                @click:append="showPwd = !showPwd"
              />
            </v-row>
          </v-container>
        </v-card-text>
      </v-form>
      <v-card-actions>
        <v-btn
          id="cancelPwd_btn"
          class="mr-2"
          @click="cancelIt"
        >
          <v-icon>
            mdi-close-circle-outline
          </v-icon>
          {{ $t('main.cancel') }}
        </v-btn>
        <v-btn
          id="setPassword_btn"
          :disabled="!formValid"
          color="primary"
          @click="setPassword"
        >
          <v-icon>
            mdi-lock-open
          </v-icon>
          {{ $t('main.ok') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    pdfFilename: {
      type: String,
      default: ''
    }
  },
  emits: ['passwordSpecified', 'passwordCancelled'],
  data() {
    return {
      dialogVisible: this.visible,
      formValid: true,
      message: '',
      showPwd: false,
      pdf_password: '',
      passwordMinCharacters: 1,
      maxCharacters: 255,
      rules: {
        required: v => !!v || this.$t('validation.form.requiredField'),
        minMax: (v) => (v && v <= this.maxCharacters) || this.$t('validation.form.mustBeLessThan', { max: this.maxCharacters })
      }
    }
  },
  watch: {
    visible: function(newVal) {
      this.dialogVisible = newVal
    },
    dialogVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    async setPassword() {
      // this.visible = false
      this.$emit('passwordSpecified', this.pdf_password)
    },
    cancelIt() {
      // this.visible = false
      this.$emit('passwordCancelled')
    },
    resetPassword() {
      this.pdf_password = ''
    }
  }

}
</script>

<style>
</style>
